import {
  DIVISION_LIST,
  DIVISION_IS_FETCHING
} from '../types'
import { api } from '../../services'

export function getDivisions () {
  return (dispatch) => {
    dispatch({
      type: DIVISION_IS_FETCHING,
      payload: true
    })

    return api.division.getDivisions()
      .then((response) => {
        if (response && !response.data.error) {
          dispatch({
            type: DIVISION_LIST,
            payload: response.data.result
          })
        }

        dispatch({
          type: DIVISION_IS_FETCHING,
          payload: false
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/division.js